import { render, staticRenderFns } from "./ModalAdicionarTelaDescanso.vue?vue&type=template&id=687d2d04&scoped=true"
import script from "./ModalAdicionarTelaDescanso.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarTelaDescanso.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarTelaDescanso.vue?vue&type=style&index=0&id=687d2d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d2d04",
  null
  
)

export default component.exports